const state = {
    avatar_url:"",
    name:"",
};

const mutations = {
    profile(state, data) {
        state.avatar_url = data.avatar_url;
        state.name=data.name;
    },
};

const actions = {

};

export default {
    state,
    mutations,
    actions
}
